import React, { Component } from 'react';
import { connect } from 'react-redux';

import FilterRadioOption from '../../../app/Search/components/filters/FilterRadioOption';
import { SiteEnum } from '../../../common/SiteConstants/SiteConstants';
import { StockItemFormat } from '../../../common/types/StockItemTypes';
import { getCurrentSite } from '../../../common/utils';
import { selectAcquisitionOption } from '../../actions/DetailsActions';
import {
  selectDetailsAcquisitionOption,
  selectDetailsStockItem,
  selectDetailsStockItemFormats,
} from '../../selectors/detailsSelectors';

import './FormatSelector.less';

interface SelectedAcquisitionOption {
  formatName: string;
}

interface Props {
  stockItemFormats: StockItemFormat[];
  selectedAcquisitionOption: SelectedAcquisitionOption;
  selectAcquisitionOption: typeof selectAcquisitionOption;
}

// TODO [FIXATHON] hookify me
class FormatSelector extends Component<Props> {
  render() {
    return (
      <div
        className="formatSelector"
        role="radiogroup"
        aria-label="Format Selector"
      >
        {this.renderAllFormats()}
      </div>
    );
  }

  renderAllFormats() {
    const downloadUrls = new Set<string>();
    const dedupedFormats: StockItemFormat[] = [];

    this.props.stockItemFormats.forEach((format) => {
      if (!downloadUrls.has(format.downloadUrl)) {
        downloadUrls.add(format.downloadUrl);
        dedupedFormats.push(format);
      }
    });

    return dedupedFormats.map((format) =>
      this.renderFormatSelector(
        format,
        this.props.selectedAcquisitionOption &&
          this.props.selectedAcquisitionOption.formatName === format.formatName
      )
    );
  }

  renderFormatSelector(format, currentSelection) {
    return (
      <div
        key={format.formatName}
        id={format.formatName}
        tabIndex={0}
        className="formatSelector-row inline-flex w-full flex items-center"
        onKeyPress={this.buildSelectFormatHandler(format)}
        onClick={this.buildSelectFormatHandler(format)}
      >
        <FilterRadioOption
          id={format.id || format.formatName}
          className="flex pl-2.5 p-0"
          inputClassName="align-center mb-2"
          label={this.qualityDescription(format) || format.formatName}
          name="format-selector"
          isChecked={currentSelection}
          onSelectOption={this.buildSelectFormatHandler(format)}
        />
        <div className="text-xs pb-1">
          {this.renderDownloadableOptionTitle(format)}
        </div>
      </div>
    );
  }

  renderDownloadableOptionTitle(format) {
    const site = getCurrentSite();

    if (site === SiteEnum.Videoblocks) {
      return `${format.formatName} ${this.formatCodec(format)} - ${
        format.filesize
      }`;
    }

    if (site === SiteEnum.Audioblocks) {
      return `(${format.label === 'MP3' ? '320 kbps' : '44,100 Hz'}) - ${
        format.filesize
      }`;
    }

    return format.filesize;
  }

  formatCodec(format) {
    if (format.codec) {
      return '(' + format.codec + ')';
    } else {
      return null;
    }
  }

  qualityDescription(format) {
    if (format.label === 'AET') {
      return 'AE';
    } else if (format.label === 'AMT') {
      return 'AMT';
    } else if (format.label === 'PPT') {
      return 'PPT';
    } else if (format.label === 'DRT') {
      return 'DRT';
    } else {
      return format.quality;
    }
  }

  buildSelectFormatHandler(format) {
    return () => {
      this.props.selectAcquisitionOption(format);
    };
  }
}

export function mapStateToProps(state) {
  return {
    stockItem: selectDetailsStockItem(state),
    selectedAcquisitionOption: selectDetailsAcquisitionOption(state),
    stockItemFormats: selectDetailsStockItemFormats(state),
  };
}

export default connect(mapStateToProps, { selectAcquisitionOption })(
  FormatSelector
);
